import template from './employeeSearchTags.html';
import controller from './employeeSearchTags.controller';
import './employeeSearchTags.scss';

let employeeSearchTagsComponent = {
  restrict: 'E',
  bindings: {
    employeeFilters: '<',
    onRemoveEmployeeFilter: '&',
    onCleanEmployeeFilters: '&'
  },
  template,
  controller
};

export default employeeSearchTagsComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/employeeSearchTags/employeeSearchTags.component.js